export { default as FontProvider } from './provider'
